import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/cfg/pricing/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 代理商运营费配置列表
export function getAgentConfigPage(data) {
  return request.send({
    url: `/pmy/sys/sys/agent/fee/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 设置代理商运营费配置
export function setAgentConfig(data) {
  return request.send({
    url: `/pmy/sys/sys/agent/fee/config`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 服务商管理费比例列表
export function getSupplierConfigPage(data) {
  return request.send({
    url: `/pmy/sys/sys/supplier/fee/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 设置服务商管理费比例
export function setSupplierConfig(data) {
  return request.send({
    url: `/pmy/sys/sys/supplier/fee/config`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 添加
export function addInfo(data) {
  return request.send({
    url: `/pmy/sys/cfg/pricing`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 编辑
export function editInfo(data) {
  return request.send({
    url: `/pmy/sys/cfg/pricing`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 删除
export function deleteInfo(pricingId) {
  return request.send({
    url: `/pmy/sys/cfg/pricing?pricingId=${pricingId}`,
    method: "delete"
  });
}
// 查询运费溢价系数配置
export function getConfig() {
  return request.send({
    url: `/pmy/sys/sys/configs/freight-coeff`,
    method: "get"
  });
}

// 修改运费溢价系数配置
export function setConfig(data) {
  return request.send({
    url: `/pmy/sys/sys/configs/freight-coeff`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}
// 下载导入模板
export function downloadTemplate(params) {
  return request.send({
    url: `/pmy/sys/cfg/pricing/template`,
    method: "get",
    params,
    config: {
      responseType: "blob"
    }
  });
}

// 导入
export function importPricing(data) {
  return request.send({
    url: `/pmy/sys/cfg/pricing/import`,
    method: "post",
    data,
    config: {
      isEncrypted: true,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  });
}
